module.exports = __webpack_public_path__ + "img/project3_medium@2x.a9622855.webp";